import { isString } from "formik";


  const createStorageFacade = storage => ({
    getItem: key => storage.getItem(key),
    setItem: (key, value) => storage.setItem(key, value),
    removeItem: key => storage.removeItem(key),
    clear: () => storage.clear(),
    keys: () => Object.keys(storage),
  });

  const sessionStorageFacade = createStorageFacade(sessionStorage);
  const persistentStorageFacade = createStorageFacade(localStorage);
  const selectedStorage = process.env.REACT_APP_ENV_VAR === "development"
    ? sessionStorageFacade
    : persistentStorageFacade;

  // All application storage access goes through this shared abstraction.
  // Use session for per-tab secrets and persistent for device preferences.
  const customStorage = {
    ...selectedStorage,
    session: sessionStorageFacade,
    persistent: persistentStorageFacade,
  };

  const formatStringPlaceholder = (route, params) => {
    const replacedRoute = route.replace(/{(\w+)}/g, (match, key) => {
      return params[key] || match; // Use the key to fetch the parameter value, or leave the placeholder intact if not found
    });
    return replacedRoute;
  };

const isNullOrEmptyString = (str) => {
   return str === null || str === undefined || (isString(str) && str.trim() === '');
}

const isNullOrUndefinedObj = (obj) => {
  return obj === null || obj === undefined;
}

  export {customStorage, formatStringPlaceholder, isNullOrEmptyString, isNullOrUndefinedObj}
